var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4231 3.75543C27.1004 2.28694 26.1547 1.12935 24.9553 0.73393C22.7642 0 13.9997 0 13.9997 0C13.9997 0 5.23548 0 3.04439 0.706104C1.86809 1.1011 0.899269 2.28715 0.576612 3.75543C0 6.43758 0 12 0 12C0 12 0 17.5905 0.576612 20.2446C0.899611 21.7129 1.84502 22.8704 3.04456 23.2659C5.25855 24 14 24 14 24C14 24 22.7642 24 24.9553 23.2939C26.1549 22.8987 27.1004 21.7411 27.4234 20.2728C27.9999 17.5905 27.9999 12.0282 27.9999 12.0282C27.9999 12.0282 28.023 6.43758 27.4231 3.75543Z",
    fill: "#F84A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7V17L19 12L11 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/yt-icon.89d4c047080016e0e0b8d8e7f968d776.svg";
export { ForwardRef as ReactComponent };